import { useMemo } from 'react'
import { useLingui } from '@lingui/react'
import { getPwaUpdateCopy } from '../components/pwa/pwa-update-copy'

/**
 * Testi modale aggiornamento PWA risolti dal catalogo Lingui attivo.
 * @returns {ReturnType<typeof getPwaUpdateCopy>}
 */
export function usePwaUpdateCopy() {
  const { i18n } = useLingui()
  const locale = i18n.locale

  return useMemo(() => getPwaUpdateCopy(i18n), [i18n, locale])
}

export default usePwaUpdateCopy
